module.exports = __webpack_public_path__ + "img/logo-agi-vertical.1d1867ed.png";